// S9: インライン検索（snippets/tol-header-inline-search.liquid）専用の Esc クローズ補完。
// Dawn の predictive-search.js は onKeyup で ArrowUp/Down/Enter のみを処理し、Esc での
// 結果パネルクローズはモーダル文脈の details-modal.js が担っていた。インライン配置では
// details-modal が存在しないため、Esc での結果リストクローズ（フォーカスは input に保持）を
// ここで補う。Dawn 本体 JS は無改修（tol- 隔離・G2 Copilot HIGH-1 対応）。
// 注（S10 実測）: 入力値は Chromium の type=search ネイティブ Esc 動作で先にクリアされ、
// その keyup を受けた predictive-search.js の `if (!getQuery().length) close(true)` が走る。
// 本リスナーの close(false) は値保持を保証しない（パネルクローズとフォーカス維持が役割）。
document.querySelectorAll('.tol-header-search predictive-search').forEach((search) => {
  search.addEventListener('keyup', (event) => {
    if (event.code !== 'Escape') return;
    if (typeof search.close === 'function') {
      search.close(false);
      if (search.input) search.input.focus();
    }
  });
});

// 0713-#11: カテゴリ選択ボックス（snippets/tol-header-inline-search.liquid）の
// ラベル切替＋外側クリッククローズ。
//
// 役割分担（Dawn 本体 JS は無改修）:
// - aria（role=button / aria-expanded / aria-controls）と Esc クローズ = assets/global.js:71-85 が
//   `[id^="Details-"] summary` の id 契約で自動付与する（本ファイルでは扱わない）。
// - focusout クローズ = assets/details-disclosure.js:11-14（<header-menu> ラッパー）。
// - ★外側クリッククローズは Dawn に無い（details-disclosure.js は focusout のみ）。
//   非フォーカス要素（body 余白・見出し等）のクリックは focusout を発火させないため
//   「領域外を押しても閉じない」= 0713-#9 と同型の不具合になる。ここで補う。
//
// 実装上の約束:
// - close は冪等な1関数（open 属性の除去 + aria-expanded 同期）。`summary.click()` や
//   無条件 toggleAttribute は使わない（native の toggle と二重発火して開閉ループになる）。
// - preventDefault / stopPropagation はしない（globo autocomplete や他ヘッダー操作の
//   クリックを殺さないため。globo は input[name="q"] にランタイム結合する）。
// - リスナーは document への「イベント委譲」で1回だけ登録する。要素ごとに直接 addEventListener
//   すると、テーマエディターの section 再描画（shopify:section:load）で差し替わった新 DOM に
//   ハンドラが付かず「ラベルが切り替わらない」状態になる（本スクリプトは defer 読み込みで
//   再評価が保証されないため）。委譲なら再描画後の要素にもそのまま効く。
// - 段階1ではスコープを送信しない。選択値は data-tol-cat-selected に保持するだけで、
//   検索 form には新しいパラメータを一切追加しない（Q54「現行踏襲」）。
(() => {
  if (window.tolSearchCatBound) return;
  window.tolSearchCatBound = true;

  const DETAILS = '.tol-header-searchcat__details';
  const ITEM = '.tol-header-searchcat__item';

  const closeDetails = (details) => {
    if (!details || !details.hasAttribute('open')) return;
    details.removeAttribute('open');
    const summary = details.querySelector('summary');
    // global.js が role=button を付ける前提のため aria-expanded を明示同期する。
    if (summary) summary.setAttribute('aria-expanded', 'false');
  };

  // 選択（委譲）: 再描画された DOM でも効く。
  document.addEventListener('click', (event) => {
    const item = event.target.closest ? event.target.closest(ITEM) : null;
    if (!item) return;
    const details = item.closest(DETAILS);
    if (!details) return;

    const labelEl = details.querySelector('[data-tol-cat-label]');
    if (labelEl) labelEl.textContent = item.textContent.trim();
    details.setAttribute('data-tol-cat-selected', item.getAttribute('data-tol-cat-value') || '');

    details.querySelectorAll(`${ITEM}[aria-current]`).forEach((el) => {
      el.removeAttribute('aria-current');
    });
    item.setAttribute('aria-current', 'true');

    closeDetails(details);
    // キーボード操作でたどり着いた場合にフォーカスが消えないよう summary へ戻す
    // （マウス選択でも害はない）。
    const summary = details.querySelector('summary');
    if (summary) summary.focus();
  });

  // 外側クリック（委譲）: Dawn に無い挙動の補完。
  document.addEventListener('pointerdown', (event) => {
    const open = document.querySelectorAll(`${DETAILS}[open]`);
    if (!open.length) return;
    open.forEach((details) => {
      // composedPath で「自分の内側の押下か」を判定する（summary 自身の押下を
      // outside 扱いすると native toggle と競合して開いた直後に閉じる）。
      const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
      const inside = path.length ? path.includes(details) : details.contains(event.target);
      if (!inside) closeDetails(details);
    });
  });
})();
